module.exports = __webpack_public_path__ + "img/zhenghuang.f7abfac9.png";